/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'plan-basic-portfolio-48x48': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<defs><path pid="0" id="svgicon_plan-basic-portfolio-48x48_a" d="M0 0h48v48H0z"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon_plan-basic-portfolio-48x48_b" _fill="#fff"><use xlink:href="#svgicon_plan-basic-portfolio-48x48_a"/></mask><g mask="url(#svgicon_plan-basic-portfolio-48x48_b)" _stroke="#181818" stroke-width="2"><path pid="1" stroke-linejoin="round" d="M23.987 26.871v13.797l-11.494 5.746L1 40.668V26.871l11.502-5.749z"/><path pid="2" d="M12.493 45.543V32.492M23.987 27.457l-11.494 5.365L1 27.457"/><path pid="3" stroke-linejoin="round" d="M46.974 26.87v13.798L35.48 46.414l-11.493-5.746V26.87l11.502-5.749z"/><path pid="4" d="M35.48 46.414V32.416M46.974 27.457L35.48 32.822l-11.493-5.365M23.987 26.864V13.026M35.48 7.91l-11.493 5.365L12.493 7.91"/><path pid="5" stroke-linejoin="round" d="M35.48 7.32v13.798l-11.493 5.746-11.494-5.746V7.32l11.503-5.748z"/></g></g>'
  }
})
